import React from "react";
import SVG, { SVGProps } from "./SVG";

const directions = {
  up: <path d="M5 3L0 9h3v4h4V9h3L5 3z"></path>,
  down: <path d="M7 7V3H3v4H0l5 6 5-6H7z"></path>,
  left: <path d="M6 3L0 8l6 5v-3h4V6H6V3z"></path>,
  right: <path d="M10 8L4 3v3H0v4h4v3l6-5z"></path>,
};

interface Props {
  direction?: keyof typeof directions;
}

const ThickArrowIcon: React.FunctionComponent<Props & SVGProps> = ({
  direction = "right",
  ...restProps
}) => (
  <SVG viewBox="0 0 10 16" {...restProps}>
    {directions[direction]}
  </SVG>
);

export default ThickArrowIcon;
